import { browseOnlyMessage, useGeo } from './context';

/** Persistent notice under the header while browse-only applies (#769: mainnet only, D1). */
export default function BrowseOnlyBanner() {
  const geo = useGeo();
  if (geo.mode !== 'browse_only') return null;
  return (
    <div role="status" className="bg-surface-2 px-4 py-1.5 text-center text-xs text-muted" data-testid="geo-browse-only">
      {browseOnlyMessage(geo.decision)}
    </div>
  );
}
